module.exports = __webpack_public_path__ + "static/media/NoDraft.53a347ac.svg";